import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAudio } from './DassPage';

const MentalHealthAssessmentPage: React.FC = () => {
  const navigate = useNavigate();
  const { isPlaying, isMuted, togglePlayPause, toggleMute } = useAudio();

  const handleStartClick = () => {
    navigate('/mentalhealth/questionnaire');
  };

  return (
    <div className="mental-health-assessment">
      {/* Floating decorative elements */}
      <span className="mental-health-assessment__floral-icon mental-health-assessment__floral-icon--top-right" aria-hidden="true">
        🌸
      </span>
      <span className="mental-health-assessment__floral-icon mental-health-assessment__floral-icon--bottom-left" aria-hidden="true">
        🌸
      </span>
      <span className="mental-health-assessment__floral-icon mental-health-assessment__floral-icon--bottom-center" aria-hidden="true">
        🌸
      </span>

      {/* Top-left glow orb */}
      <div className="mental-health-assessment__glow-orb" aria-hidden="true"></div>

      {/* Main content */}
      <main className="mental-health-assessment__main">
        <h1 className="mental-health-assessment__title">
          Mental Wellness<br />Assessment
        </h1>
        <button
          className="mental-health-assessment__start-btn"
          onClick={handleStartClick}
        >
          LET'S START
        </button>
      </main>

      {/* Bottom-right control stack */}
      <div className="mental-health-assessment__control-stack">
        <button className="mental-health-assessment__control-btn" onClick={togglePlayPause} aria-label="Play/Pause music">
          {isPlaying ? '⏸' : '▶'}
        </button>
        <button className="mental-health-assessment__control-btn" onClick={toggleMute} aria-label="Mute/Unmute music">
          {isMuted ? '🔇' : '🔊'}
        </button>
      </div>
    </div>
  );
};

export default MentalHealthAssessmentPage;

